<template>
  <div class="filter-title d-flex justify-content-between align-items-center mb-lg-4 mb-2">
    <div>
      <h4 v-if="!title">
        <skeleton-loader-vue :height="23" :width="308" type="string" />
      </h4>
      <h4 v-else>{{ title }}</h4>
      <p class="mb-0">{{ subtitle }}</p>
    </div>
    <div v-if="$route.name == 'Home' && restaurantData" class="d-flex">
      <div class="d-flex" v-if="restaurantData.restaurant_on_off == '1'">
        <img src="@/assets/images/Tumer.svg" />
        <h6 class="mb-0 ml-1">
          {{ getScheduleText(restaurantData.delivery_times) }}
        </h6>
      </div>
      <div class="d-flex list-shedule-bg" v-else data-toggle="tooltip" data-placement="top"
        :title="$t('Restaurant is currently closed,Schedule your order now.')">
        <b-icon icon="exclamation-circle"></b-icon>
        <h6 class="mb-0 ml-1">Schedule</h6>
      </div>
    </div>
    <slot />
  </div>
</template>
<script>
import VueSkeletonLoader from "skeleton-loader-vue";
export default {
  components: {
    "skeleton-loader-vue": VueSkeletonLoader,
  },
  props: ["title", "subtitle", "restaurantData"],
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    getScheduleText(value) {
      let min = value.toString().toLowerCase().replace("mins", "");
      return min + "-" + (parseInt(min) + 5) + " mins";
    },
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
  cursor: default;
}

.tooltip .tooltiptext {
  visibility: hidden;
  padding: 0.25em 0.5em;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 0.25em;
  white-space: nowrap;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 100%;
  transition-property: visibility;
  transition-delay: 0s;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  transition-delay: 0.3s;
}
</style>
